module.exports = __webpack_public_path__ + "img/stage-unassigned.4712c37b.svg";